/* eslint-disable max-len */
/* eslint-disable react/jsx-key */
import React from "react";
import { useNavigate } from "react-router-dom";
import Noresult from "./Noresult";

export default function ViewAdminList() {
    const addAdminNavigate = useNavigate();

    return (
        <div className="flex-grow ">
            <div className="py-[41px] pl-[32px] bg-white shadow-custom">
                <h1 className="font-playfair text-[#4B4B4B] text-xl font-medium">
                    Admin User
                </h1>
            </div>
            <div className="bg-[#f5f5f5] pl-[15px] pt-[15px] h-customh7 ">
                <div className="bg-white px-6 font-medium text-[#4B4B4B] h-full">
                    <div className="flex py-6 justify-between items-center pr-[66px]">
                        <h1 className="font-playfair text-xl">Admin User List</h1>
                        <div className="flex justify-center items-center space-x-10">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Name, Email Address, Phone Number"
                                    className="w-[314px] h-10 rounded-[8px] pl-[14px] py-4 border border-[#1F1F1F] placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] outline-none"
                                />
                                <img
                                    src="/assets/images/search.svg"
                                    alt=""
                                    className="absolute top-[11px] right-[19px]"
                                />
                            </div>
                            <img
                                src="/assets/images/plus.svg"
                                className="cursor-pointer"
                                alt=""
                                onClick={() => addAdminNavigate("/addadminuser")}
                                data-te-toggle="tooltip"
                                data-te-placement="top"
                                data-te-ripple-init
                                data-te-ripple-color="light"
                                title="Tooltip on top"
                            />

                            {totaldata > 1 && (
                                <button className="px-4 py-[10px] font-normal text-sm border border-[#9E2064] text-primary rounded-[12px]">
                                    Export
                                </button>
                            )}
                        </div>
                    </div>

                    {arr.length > 1 ? (
                        <div>
                            <table className="w-full">
                                <thead>
                                    <tr className="border-b-[1px] border-[#EEEEEE]">
                                        <th className="flex space-x-1 px-4 py-3">
                                            <h1 className="text-sm text-[#4B4B4B] font-medium">Name</h1>
                                            <img src="/assets/images/sort-pink.svg" alt="" onClick={() => handleSort('name')}
                                                className={`cursor-pointer ${CheckSort('name') ? 'rotate-180' : ''}`} />
                                        </th>
                                        <th className="px-4 py-3">
                                            <h1 className="text-sm text-[#4B4B4B] font-medium text-center">Email Address</h1>
                                        </th>
                                        <th className="px-4 py-3">
                                            <h1 className="text-sm text-[#4B4B4B] font-medium ">Phone Number</h1>
                                        </th>
                                        <th className="flex space-x-1 px-4 py-3 justify-center">
                                            <h1 className="text-sm text-[#4B4B4B] font-medium">Status</h1>
                                            <img src="/assets/images/sort-pink.svg" alt="" onClick={() => handleSort('status')}
                                                className={`cursor-pointer ${CheckSort('status') ? 'rotate-180' : ''}`} />
                                        </th>
                                        <th className="px-4 py-3">
                                            <h1 className="text-sm text-[#4B4B4B] font-medium">Action</h1>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index} className="border-b-[1px] border-[#EEEEEE]">
                                            <td className="px-4 py-3">
                                                <h1 className="text-sm">{item.name}</h1>
                                            </td>
                                            <td className="px-4 py-3 ">
                                                <h1 className="text-sm text-center">{item.email}</h1>
                                            </td>
                                            <td className="px-4 py-3">
                                                <h1 className="text-sm text-center">{item.phone}</h1>
                                            </td>
                                            <td className="px-4 py-3 ">
                                                {getStatusContent(item.status)}
                                            </td>
                                            <td className="px-4 py-3 flex justify-center">
                                                <img src="/assets/images/Edit.svg" alt="" />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <Noresult />
                    )}

                    {arr.length > 1 && (
                        <div className="mt-[26px] pb-[85px] flex justify-end">
                            <div className="flex pr-[60px] pt-3 pb-4 space-x-2 ">
                                <img src="../../src/assets/images/Left.svg" alt="" />
                                <button className="px-[5px]">1</button>
                                <button className="px-[5px]">2</button>
                                <button className="px-[5px]">3</button>
                                <button className="px-[5px] bg-[#FBEBF4]">4</button>
                                <button className="px-[5px]">5</button>
                                <button className="px-[5px]">...</button>
                                <button className="px-[5px]">10</button>
                                <img src="../../src/assets/images/Right.svg" alt="" />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
